import { useState } from 'react'
import { HelpCircle, Scale, X } from 'lucide-react'
import { STATE_TERMS } from './stateTermsConstants'

export function EvictionLawsuitHelpModal({ disabled = false }: { disabled?: boolean }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        className="group inline-flex items-center gap-1.5 text-xs font-medium text-blue-600 transition-colors hover:text-blue-800 disabled:cursor-not-allowed"
      >
        <HelpCircle size={14} className="opacity-70 transition-opacity group-hover:opacity-100" />
        <span>What counts as an Eviction Lawsuit in my state?</span>
      </button>

      {isOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div
            className="flex max-h-[85vh] w-full max-w-2xl flex-col rounded-xl bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between border-b border-gray-100 px-6 pb-4 pt-5">
              <div className="flex items-start gap-3">
                <div className="mt-0.5 rounded-lg bg-blue-50 p-2">
                  <Scale className="text-blue-600" size={20} />
                </div>
                <div>
                  <h2 className="text-base font-semibold leading-tight text-gray-900">
                    State-Specific Eviction Lawsuit Equivalents
                  </h2>
                  <p className="mt-1 max-w-md text-xs leading-relaxed text-gray-500">
                    If your state does not use the term &quot;Eviction Lawsuit&quot; please see the table
                    below to find the appropriate term for your state.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="-mr-1 -mt-1 rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
              >
                <X size={18} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-4">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b-2 border-gray-200">
                    <th className="w-[35%] py-2.5 pr-4 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                      State
                    </th>
                    <th className="py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                      Formal Legal Term
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {STATE_TERMS.map(([state, term], i) => (
                    <tr
                      key={state}
                      className={`border-b border-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} transition-colors hover:bg-blue-50/40`}
                    >
                      <td className="py-2 pr-4 text-sm font-medium text-gray-900">{state}</td>
                      <td className="py-2 text-sm text-gray-700">{term}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="rounded-b-xl border-t border-gray-100 bg-gray-50 px-6 py-3">
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
